// HMRC SDLT local authority codes (SDLTM62320).
// Source: https://www.gov.uk/hmrc-internal-manuals/stamp-duty-land-tax-manual/sdltm62320
// Used for SDLT1 Q29 (1.29 online). A valid code is MANDATORY — HMRC rejects
// a return with a missing/invalid code. The list includes some authorities
// that no longer exist, to allow late notification of older transactions.
// Welsh authorities are intentionally excluded (Wales uses LTT since 1/4/2018);
// use code 6999 only for transitional Welsh cases.
// Comma-inverted alias spellings (e.g. "Cambridgeshire, East") are omitted —
// the natural form ("East Cambridgeshire") is kept.

export const LA_CODES = [
  { name: "Adur", code: "3805" },
  { name: "Allerdale", code: "0905" },
  { name: "Alnwick", code: "2905" },
  { name: "Amber Valley", code: "1005" },
  { name: "Antrim", code: "7005" },
  { name: "Ards", code: "7010" },
  { name: "Armagh", code: "7015" },
  { name: "Arun", code: "3810" },
  { name: "Ashfield", code: "3005" },
  { name: "Ashford", code: "2205" },
  { name: "Aylesbury Vale", code: "0405" },
  { name: "Babergh", code: "3505" },
  { name: "Ballymena", code: "7020" },
  { name: "Ballymoney", code: "7025" },
  { name: "Banbridge", code: "7030" },
  { name: "Barking and Dagenham", code: "5060" },
  { name: "Barnet", code: "5090" },
  { name: "Barnsley", code: "4405" },
  { name: "Barrow-in-Furness", code: "0910" },
  { name: "Basildon", code: "1505" },
  { name: "Basingstoke and Deane", code: "1705" },
  { name: "Bassetlaw", code: "3010" },
  { name: "Bath and North East Somerset", code: "0114" },
  { name: "Bedford", code: "0205" },
  { name: "Belfast", code: "7035" },
  { name: "Berwick-upon-Tweed", code: "2910" },
  { name: "Bexley", code: "5120" },
  { name: "Birmingham", code: "4605" },
  { name: "Blaby", code: "2405" },
  { name: "Blackburn with Darwen", code: "2372" },
  { name: "Blackpool", code: "2373" },
  { name: "Blyth Valley", code: "2915" },
  { name: "Bolsover", code: "1010" },
  { name: "Bolton", code: "4205" },
  { name: "Boston", code: "2505" },
  { name: "Bournemouth", code: "1250" },
  { name: "Bracknell Forest", code: "0335" },
  { name: "Bradford", code: "4705" },
  { name: "Braintree", code: "1510" },
  { name: "Breckland", code: "2605" },
  { name: "Brent", code: "5150" },
  { name: "Brentwood", code: "1515" },
  { name: "Bridgnorth", code: "3205" },
  { name: "Brighton and Hove", code: "1445" },
  { name: "Bristol", code: "0116" },
  { name: "Broadland", code: "2610" },
  { name: "Bromley", code: "5180" },
  { name: "Bromsgrove", code: "1805" },
  { name: "Broxbourne", code: "1905" },
  { name: "Broxtowe", code: "3015" },
  { name: "Burnley", code: "2315" },
  { name: "Bury", code: "4210" },
  { name: "Calderdale", code: "4710" },
  { name: "Cambridge", code: "0505" },
  { name: "Camden", code: "5210" },
  { name: "Cannock Chase", code: "3405" },
  { name: "Canterbury", code: "2210" },
  { name: "Caradon", code: "0805" },
  { name: "Carlisle", code: "0915" },
  { name: "Carrick", code: "0810" },
  { name: "Carrickfergus", code: "7040" },
  { name: "Castle Morpeth", code: "2920" },
  { name: "Castle Point", code: "1520" },
  { name: "Castlereagh", code: "7045" },
  { name: "Central Bedfordshire", code: "0215" },
  { name: "Charnwood", code: "2410" },
  { name: "Chelmsford", code: "1525" },
  { name: "Cheltenham", code: "1605" },
  { name: "Cherwell", code: "3105" },
  { name: "Cheshire East", code: "0630" },
  { name: "Chester", code: "0605" },
  { name: "Chester-le-Street", code: "1305" },
  { name: "Chesterfield", code: "1015" },
  { name: "Chichester", code: "3815" },
  { name: "Chiltern", code: "0415" },
  { name: "Chorley", code: "2320" },
  { name: "Christchurch", code: "1210" },
  { name: "City of Leicester", code: "2465" },
  { name: "City of London", code: "5030" },
  { name: "City of York", code: "2741" },
  { name: "Colchester", code: "1530" },
  { name: "Coleraine", code: "7050" },
  { name: "Congleton", code: "0610" },
  { name: "Cookstown", code: "7055" },
  { name: "Copeland", code: "0920" },
  { name: "Corby", code: "2805" },
  { name: "Cornwall", code: "0810" },
  { name: "Cotswold", code: "1610" },
  { name: "Coventry", code: "4610" },
  { name: "Craigavon", code: "7060" },
  { name: "Craven", code: "2705" },
  { name: "Crawley", code: "3820" },
  { name: "Crewe and Nantwich", code: "0615" },
  { name: "Croydon", code: "5240" },
  { name: "Dacorum", code: "1910" },
  { name: "Darlington", code: "1350" },
  { name: "Dartford", code: "2215" },
  { name: "Daventry", code: "2810" },
  { name: "Derby", code: "1055" },
  { name: "Derbyshire Dales", code: "1045" },
  { name: "Derry", code: "7095" },
  { name: "Derwentside", code: "1315" },
  { name: "Doncaster", code: "4410" },
  { name: "Dover", code: "2220" },
  { name: "Down", code: "7065" },
  { name: "Dudley", code: "4615" },
  { name: "Dungannon", code: "7070" },
  { name: "Durham", code: "1320" },
  { name: "Ealing", code: "5270" },
  { name: "Easington", code: "1325" },
  { name: "East Cambridgeshire", code: "0510" },
  { name: "East Devon", code: "1105" },
  { name: "East Dorset", code: "1240" },
  { name: "East Hampshire", code: "1710" },
  { name: "East Hertfordshire", code: "1915" },
  { name: "East Lindsey", code: "2510" },
  { name: "East Northamptonshire", code: "2815" },
  { name: "East Riding of Yorkshire", code: "2001" },
  { name: "East Staffordshire", code: "3410" },
  { name: "Eastbourne", code: "1410" },
  { name: "Eastleigh", code: "1715" },
  { name: "Eden", code: "0925" },
  { name: "Ellesmere Port and Neston", code: "0620" },
  { name: "Elmbridge", code: "3605" },
  { name: "Enfield", code: "5300" },
  { name: "Epping Forest", code: "1535" },
  { name: "Epsom and Ewell", code: "3610" },
  { name: "Erewash", code: "1025" },
  { name: "Exeter", code: "1110" },
  { name: "Fareham", code: "1720" },
  { name: "Fenland", code: "0515" },
  { name: "Fermanagh", code: "7075" },
  { name: "Forest Heath", code: "3510" },
  { name: "Forest of Dean", code: "1615" },
  { name: "Fylde", code: "2325" },
  { name: "Gateshead", code: "4505" },
  { name: "Gedling", code: "3020" },
  { name: "Gloucester", code: "1620" },
  { name: "Gosport", code: "1725" },
  { name: "Gravesham", code: "2230" },
  { name: "Great Yarmouth", code: "2615" },
  { name: "Greenwich", code: "5330" },
  { name: "Guildford", code: "3615" },
  { name: "Hackney", code: "5360" },
  { name: "Halton", code: "0650" },
  { name: "Hambleton", code: "2710" },
  { name: "Hammersmith and Fulham", code: "5390" },
  { name: "Harborough", code: "2415" },
  { name: "Haringey", code: "5420" },
  { name: "Harlow", code: "1540" },
  { name: "Harrogate", code: "2715" },
  { name: "Harrow", code: "5450" },
  { name: "Hart", code: "1730" },
  { name: "Hartlepool", code: "0724" },
  { name: "Hastings", code: "1415" },
  { name: "Havant", code: "1735" },
  { name: "Havering", code: "5480" },
  { name: "Herefordshire", code: "1850" },
  { name: "Hertsmere", code: "1920" },
  { name: "High Peak", code: "1030" },
  { name: "Hillingdon", code: "5510" },
  { name: "Hinckley and Bosworth", code: "2420" },
  { name: "Horsham", code: "3825" },
  { name: "Hounslow", code: "5540" },
  { name: "Huntingdonshire", code: "0520" },
  { name: "Hyndburn", code: "2330" },
  { name: "Ipswich", code: "3515" },
  { name: "Isle of Wight", code: "2100" },
  { name: "Isles of Scilly", code: "0835" },
  { name: "Islington", code: "5570" },
  { name: "Kennet", code: "3905" },
  { name: "Kensington and Chelsea", code: "5600" },
  { name: "Kerrier", code: "0815" },
  { name: "Kettering", code: "2820" },
  { name: "Kings Lynn and West Norfolk", code: "2635" },
  { name: "Kingston-upon-Hull (City and county)", code: "2004" },
  { name: "Kingston-upon-Thames", code: "5630" },
  { name: "Kirklees", code: "4715" },
  { name: "Knowsley", code: "4305" },
  { name: "Lambeth", code: "5660" },
  { name: "Lancaster", code: "2335" },
  { name: "Larne", code: "7080" },
  { name: "Leeds", code: "4720" },
  { name: "Lewes", code: "1425" },
  { name: "Lewisham", code: "5690" },
  { name: "Lichfield", code: "3415" },
  { name: "Limavady", code: "7085" },
  { name: "Lincoln", code: "2515" },
  { name: "Lisburn", code: "7090" },
  { name: "Liverpool", code: "4310" },
  { name: "Luton", code: "0230" },
  { name: "Macclesfield", code: "0630" },
  { name: "Magherafelt", code: "7100" },
  { name: "Maidstone", code: "2235" },
  { name: "Maldon", code: "1545" },
  { name: "Malvern Hills", code: "1860" },
  { name: "Manchester", code: "4215" },
  { name: "Mansfield", code: "3025" },
  { name: "Medway", code: "2280" },
  { name: "Melton", code: "2430" },
  { name: "Mendip", code: "3305" },
  { name: "Merton", code: "5720" },
  { name: "Mid-Devon", code: "1135" },
  { name: "Mid-Suffolk", code: "3520" },
  { name: "Mid-Sussex", code: "3830" },
  { name: "Middlesbrough", code: "0734" },
  { name: "Milton Keynes", code: "0435" },
  { name: "Mole Valley", code: "3620" },
  { name: "Moyle", code: "7110" },
  { name: "New Forest", code: "1740" },
  { name: "Newark and Sherwood", code: "3030" },
  { name: "Newcastle-under-Lyme", code: "3420" },
  { name: "Newcastle-upon-Tyne", code: "4510" },
  { name: "Newham", code: "5750" },
  { name: "Newry and Mourne", code: "7105" },
  { name: "Newtownabbey", code: "7115" },
  { name: "North Cornwall", code: "0820" },
  { name: "North Devon", code: "1115" },
  { name: "North Dorset", code: "1215" },
  { name: "North Down", code: "7120" },
  { name: "North East Derbyshire", code: "1035" },
  { name: "North East Lincolnshire", code: "2002" },
  { name: "North Hertfordshire", code: "1925" },
  { name: "North Kesteven", code: "2520" },
  { name: "North Lincolnshire", code: "2003" },
  { name: "North Norfolk", code: "2620" },
  { name: "North Shropshire", code: "3210" },
  { name: "North Somerset", code: "0121" },
  { name: "North Tyneside", code: "4515" },
  { name: "North Warwickshire", code: "3705" },
  { name: "North West Leicestershire", code: "2435" },
  { name: "North Wiltshire", code: "3910" },
  { name: "Northampton", code: "2825" },
  { name: "Northumberland", code: "2920" },
  { name: "Norwich", code: "2625" },
  { name: "Nottingham", code: "3060" },
  { name: "Nuneaton and Bedworth", code: "3710" },
  { name: "Oadby and Wigston", code: "2440" },
  { name: "Oldham", code: "4220" },
  { name: "Omagh", code: "7125" },
  { name: "Oswestry", code: "3215" },
  { name: "Oxford", code: "3110" },
  { name: "Pendle", code: "2340" },
  { name: "Penwith", code: "0825" },
  { name: "Peterborough", code: "0540" },
  { name: "Plymouth", code: "1160" },
  { name: "Poole", code: "1255" },
  { name: "Portsmouth City Council", code: "1775" },
  { name: "Preston", code: "2345" },
  { name: "Purbeck", code: "1225" },
  { name: "Reading", code: "0345" },
  { name: "Redbridge", code: "5780" },
  { name: "Redcar and Cleveland", code: "0728" },
  { name: "Redditch", code: "1825" },
  { name: "Reigate and Banstead", code: "3625" },
  { name: "Restormel", code: "0830" },
  { name: "Ribble Valley", code: "2350" },
  { name: "Richmond-upon-Thames", code: "5810" },
  { name: "Richmondshire", code: "2720" },
  { name: "Rochdale", code: "4225" },
  { name: "Rochford", code: "1550" },
  { name: "Rossendale", code: "2355" },
  { name: "Rother", code: "1430" },
  { name: "Rotherham", code: "4415" },
  { name: "Rugby", code: "3715" },
  { name: "Runnymede", code: "3630" },
  { name: "Rushcliffe", code: "3040" },
  { name: "Rushmoor", code: "1750" },
  { name: "Rutland", code: "2470" },
  { name: "Ryedale", code: "2725" },
  { name: "St Albans", code: "1930" },
  { name: "St Edmundsbury", code: "3525" },
  { name: "St Helens", code: "4315" },
  { name: "Salford", code: "4230" },
  { name: "Salisbury", code: "3915" },
  { name: "Sandwell", code: "4620" },
  { name: "Scarborough", code: "2730" },
  { name: "Sedgefield", code: "1330" },
  { name: "Sedgemoor", code: "3310" },
  { name: "Sefton", code: "4320" },
  { name: "Selby", code: "2735" },
  { name: "Sevenoaks", code: "2245" },
  { name: "Sheffield", code: "4420" },
  { name: "Shepway", code: "2250" },
  { name: "Shrewsbury and Atcham", code: "3220" },
  { name: "Shropshire", code: "3220" },
  { name: "Slough", code: "0350" },
  { name: "Solihull", code: "4625" },
  { name: "South Bedfordshire", code: "0220" },
  { name: "South Bucks", code: "0410" },
  { name: "South Cambridgeshire", code: "0530" },
  { name: "South Derbyshire", code: "1040" },
  { name: "South Gloucestershire", code: "0119" },
  { name: "South Hams", code: "1125" },
  { name: "South Holland", code: "2525" },
  { name: "South Kesteven", code: "2530" },
  { name: "South Lakeland", code: "0930" },
  { name: "South Norfolk", code: "2630" },
  { name: "South Northamptonshire", code: "2830" },
  { name: "South Oxfordshire", code: "3115" },
  { name: "South Ribble", code: "2360" },
  { name: "South Shropshire", code: "3225" },
  { name: "South Somerset", code: "3325" },
  { name: "South Staffordshire", code: "3430" },
  { name: "South Tyneside", code: "4520" },
  { name: "Southampton", code: "1780" },
  { name: "Southend-on-Sea", code: "1590" },
  { name: "Southwark", code: "5840" },
  { name: "Spelthorne", code: "3635" },
  { name: "Stafford", code: "3425" },
  { name: "Staffordshire Moorlands", code: "3435" },
  { name: "Stevenage", code: "1935" },
  { name: "Stockport", code: "4235" },
  { name: "Stockton-on-Tees", code: "0738" },
  { name: "Stoke-on-Trent", code: "3455" },
  { name: "Strabane", code: "7130" },
  { name: "Stratford-upon-Avon", code: "3720" },
  { name: "Stroud", code: "1625" },
  { name: "Suffolk Coastal", code: "3530" },
  { name: "Sunderland", code: "4525" },
  { name: "Surrey Heath", code: "3640" },
  { name: "Sutton", code: "5870" },
  { name: "Swale", code: "2255" },
  { name: "Swindon", code: "3935" },
  { name: "Tameside", code: "4240" },
  { name: "Tamworth", code: "3445" },
  { name: "Tandridge", code: "3645" },
  { name: "Taunton Deane", code: "3315" },
  { name: "Teesdale", code: "1335" },
  { name: "Teignbridge", code: "1130" },
  { name: "Telford and Wrekin", code: "3240" },
  { name: "Tendring", code: "1560" },
  { name: "Test Valley", code: "1760" },
  { name: "Tewkesbury", code: "1630" },
  { name: "Thanet", code: "2260" },
  { name: "Three Rivers", code: "1940" },
  { name: "Thurrock", code: "1595" },
  { name: "Tonbridge and Malling", code: "2265" },
  { name: "Torbay", code: "1165" },
  { name: "Torridge", code: "1145" },
  { name: "Tower Hamlets", code: "5900" },
  { name: "Trafford", code: "4245" },
  { name: "Tunbridge Wells", code: "2270" },
  { name: "Tynedale", code: "2925" },
  { name: "Uttlesford", code: "1570" },
  { name: "Vale of White Horse", code: "3120" },
  { name: "Vale Royal", code: "0635" },
  { name: "Wakefield", code: "4725" },
  { name: "Walsall", code: "4630" },
  { name: "Waltham Forest", code: "5930" },
  { name: "Wandsworth", code: "5960" },
  { name: "Wansbeck", code: "2930" },
  { name: "Warrington", code: "0655" },
  { name: "Warwick", code: "3725" },
  { name: "Watford", code: "1945" },
  { name: "Waveney", code: "3535" },
  { name: "Waverley", code: "3650" },
  { name: "Wealden", code: "1435" },
  { name: "Wear Valley", code: "1340" },
  { name: "Wellingborough", code: "2835" },
  { name: "Welwyn Hatfield", code: "1950" },
  { name: "West Berkshire", code: "0340" },
  { name: "West Devon", code: "1150" },
  { name: "West Dorset", code: "1230" },
  { name: "West Lancashire", code: "2365" },
  { name: "West Lindsey", code: "2535" },
  { name: "West Oxfordshire", code: "3125" },
  { name: "West Somerset", code: "3320" },
  { name: "West Wiltshire", code: "3925" },
  { name: "Westminster City", code: "5990" },
  { name: "Weymouth and Portland", code: "1235" },
  { name: "Wigan", code: "4250" },
  { name: "Wiltshire", code: "3915" },
  { name: "Winchester", code: "1765" },
  { name: "Windsor and Maidenhead", code: "0355" },
  { name: "Wirral", code: "4325" },
  { name: "Woking", code: "3655" },
  { name: "Wokingham", code: "0360" },
  { name: "Wolverhampton", code: "4635" },
  { name: "Worcester", code: "1835" },
  { name: "Worthing", code: "3835" },
  { name: "Wychavon", code: "1840" },
  { name: "Wycombe", code: "0425" },
  { name: "Wyre", code: "2370" },
  { name: "Wyre Forest", code: "1845" },
];

// Options for a combobox: value = code, label = "Name (code)".
export const LA_OPTIONS = LA_CODES.map((la) => ({
  value: la.code,
  label: `${la.name} (${la.code})`,
  name: la.name,
}));
